import { JSX, h } from "@stencil/core";
import {
  NavigationModeType,
  NavigationThemeType,
} from "@phn/utility/constants";
import { getRightTheme } from "@phn/utility/helper";

export const BadgeCount = ({
  numberOfItems,
  theme,
  mode,
}: {
  numberOfItems: number;
  theme: NavigationThemeType;
  mode: NavigationModeType;
}): JSX.Element => {
  const displayedItemLimit = 99;
  const badgeItemCountLimit = 10;

  const itemCountOver99 = "99+";
  const displayedCount =
    numberOfItems < displayedItemLimit ? numberOfItems : itemCountOver99;

  if (numberOfItems <= 0) return "";

  return (
    <span
      class={`badge-item-count ${
        numberOfItems < badgeItemCountLimit ? "" : "pill"
      } ${getRightTheme(theme, mode)}`}
      data-id="badge-item-count"
    >
      {displayedCount}
    </span>
  );
};
